module.exports = __webpack_public_path__ + "img/Produtos003.3d51d9f5.png";